import { Link } from "react-router-dom";

const PendingLoanCard = () => {
  return (
    <div className="w-full bg-[#003399]/10 border border-[#003399]/30 rounded-xl p-4 md:p-6 shadow-sm">
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="w-12 h-12 rounded-full bg-[#ED6E0A]/20 flex items-center justify-center">
          <svg
            className="w-6 h-6 text-[#ED6E0A]"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3m0 4h.01M12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5z"
            />
          </svg>
        </div>

        {/* Text */}
        <div className="flex-1">
          <h3 className="text-[#003399] font-semibold text-base sm:text-lg md:text-xl">
            You have a pending loan application
          </h3>

          <p className="text-gray-600 text-xs sm:text-sm md:text-base mt-1">
            Your loan request is still being reviewed.  
            You’ll be notified once it has been approved or rejected.
          </p>
        </div>
      </div>

      {/* CTA */}
      <div className="mt-4">
        <Link to="/main/dashboard" className="px-4 py-2 text-sm sm:text-base font-medium rounded-lg bg-[#6699FF] text-white hover:bg-[#003399] transition">
       
          View Pass Book
        </Link>
      </div>
    </div>
  );
};

export default PendingLoanCard;
